export const urlLinks = {
  // baseUrl: "https://qaapieflex.okaygo.in",
  baseUrl: "https://apieflex.okaygo.in",
  // baseUrlTask: "https://uat.okaygoprod.in/",
  baseUrlTask: "https://task.okaygodev.in/",
  attendanceHistory: "workerdata/getWorkerAttendanceDetails",
  checkUserStatus: "checkUserStatus",
  getProjects: "getAllProjectByUserId",
  taskModal: "task-model",
  addUserRolePhoneNumber: "addUserRolePhoneNumber",
  saveWorkerAttendance: "workerdata/saveWorkerAttendance",
  setUserBindToken: "setUserBindToken",
  taskExecution: {
    getOnboardTokenByUserId: "getOnboradTokenByUserId",
    processInstances: "api/apps/process-instances",
    step_progress: "api/apps/step_progress",
    tasks: "org/tasks",
  },
  workerV2: {
    getWorkerDetails: "worker/v2/getWorkerDetails",
  },
  
};
